import { Cell } from 'react-table';
import { Typography } from '@material-ui/core';

export const DefaultCellRenderer = (value: Cell<Record<string, unknown>, unknown>) => (
	<Typography variant="body2">{`${value.value}`}</Typography>
);
